if (typeof active_affiliate !== 'undefined') {
  const announcement_bar = document.querySelector("#announcement__slider")

  if (announcement_bar) {
    const slideContainer = document.createElement("div")
    slideContainer.className = "keen-slider__slide"

    const affiliate_msg = document.createElement("h6")
    affiliate_msg.className = "announcement-bar__message announcement-bar__message--affiliate mobile--smaller"

    const parts = active_affiliate.msg.split("_code_")

    const link = document.createElement("a")
    link.href = "/collections/" + active_affiliate.collection_handle 
    link.classList.add("announcement-bar__message--affiliate"); 
    link.appendChild(document.createTextNode(parts[0]))
    affiliate_msg.appendChild(link);

    const discountCode = document.createElement("span");
    discountCode.classList.add("textToCopy"); 
    discountCode.textContent = active_affiliate.discount_code // the actual code instead of _code_
    affiliate_msg.appendChild(discountCode);
    discountCode.addEventListener('click', function (e) {
      let textToCopy = e.target.innerText;
      copyToClipboard(textToCopy);
    });


    if (parts[1]) { 
      const link2 = document.createElement("a")
      link2.href = "/collections/" + active_affiliate.collection_handle 
      link2.classList.add("announcement-bar__message--affiliate"); 
      link2.appendChild(document.createTextNode(parts[1]))
      affiliate_msg.appendChild(link2);
    }
    
    slideContainer.appendChild(affiliate_msg)
    announcement_bar.insertBefore( slideContainer,  announcement_bar.children[1] || null );
    window?.announcementSlider.update();

    // set a new cookie expires after 7 days for the new message
    if (getCookie('affiliate_announcement') != slideContainer.outerHTML) {
      setCookie('affiliate_announcement',  slideContainer.outerHTML, 7)
    }

  }
}